export function mapCheckoutSdkToCheckout(response) {
  return replaceKeys(response, {
    _id: 'id',
    addressLine1: 'addressLine'
  });
}
function replaceKeys(obj, replaces) {
  if (Array.isArray(obj)) {
    return obj.map(o => replaceKeys(o, replaces));
  }
  if (obj && typeof obj === 'object') {
    return Object.fromEntries(Object.entries(obj).map(_ref => {
      let [key, value] = _ref;
      return [replaces[key] ? replaces[key] : key, replaceKeys(value, replaces)];
    }));
  }
  return obj;
}
//# sourceMappingURL=mapCheckoutSdkToCheckout.js.map